import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@ui5/webcomponents-react';
import LandingPage from './pages/LandingPage';
import RegisterPage from './pages/RegisterPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AgbPage from './pages/AgbPage';
import WiderrufPage from './pages/WiderrufPage';
import DashboardPage from './pages/DashboardPage';
import SetupWizardPage from './pages/SetupWizardPage';
import OrganizationPage from './pages/OrganizationPage';
import ProcessingListPage from './pages/ProcessingListPage';
import ProcessingWizardPage from './pages/ProcessingWizardPage';
import ProcessingDetailPage from './pages/ProcessingDetailPage';
import ServiceProviderListPage from './pages/ServiceProviderListPage';
import ServiceProviderWizardPage from './pages/ServiceProviderWizardPage';
import ServiceProviderDetailPage from './pages/ServiceProviderDetailPage';
import PrivacyNoticeListPage from './pages/PrivacyNoticeListPage';
import PrivacyNoticeWizardPage from './pages/PrivacyNoticeWizardPage';
import PrivacyNoticeDetailPage from './pages/PrivacyNoticeDetailPage';
import ImportPage from './pages/ImportPage';
import ExportPage from './pages/ExportPage';
import ReportsPage from './pages/ReportsPage';
import TomListPage from './pages/TomListPage';
import TomWizardPage from './pages/TomWizardPage';
import TomDetailPage from './pages/TomDetailPage';
import DsrListPage from './pages/DsrListPage';
import DsrWizardPage from './pages/DsrWizardPage';
import DsrDetailPage from './pages/DsrDetailPage';
import BreachListPage from './pages/BreachListPage';
import BreachWizardPage from './pages/BreachWizardPage';
import BreachDetailPage from './pages/BreachDetailPage';
import UserManagementPage from './pages/UserManagementPage';
import BillingPage from './pages/BillingPage';
import OnboardingPage from './pages/OnboardingPage';
import AdminPanelPage from './pages/AdminPanelPage';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';

function ProtectedWithLayout({ children }: { children: React.ReactNode }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LandingPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/agb" element={<AgbPage />} />
          <Route path="/widerruf" element={<WiderrufPage />} />
          <Route path="/admin" element={<AdminPanelPage />} />
          <Route
            path="/setup"
            element={
              <ProtectedRoute>
                <SetupWizardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/organization"
            element={
              <ProtectedWithLayout>
                <OrganizationPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedWithLayout>
                <DashboardPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/onboarding"
            element={
              <ProtectedWithLayout>
                <OnboardingPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/processing"
            element={
              <ProtectedWithLayout>
                <ProcessingListPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/processing/new"
            element={
              <ProtectedWithLayout>
                <ProcessingWizardPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/processing/:id"
            element={
              <ProtectedWithLayout>
                <ProcessingDetailPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/processing/:id/edit"
            element={
              <ProtectedWithLayout>
                <ProcessingWizardPage editMode />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/service-providers"
            element={
              <ProtectedWithLayout>
                <ServiceProviderListPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/service-providers/new"
            element={
              <ProtectedWithLayout>
                <ServiceProviderWizardPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/service-providers/:id"
            element={
              <ProtectedWithLayout>
                <ServiceProviderDetailPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/service-providers/:id/edit"
            element={
              <ProtectedWithLayout>
                <ServiceProviderWizardPage editMode />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/privacy-notices"
            element={
              <ProtectedWithLayout>
                <PrivacyNoticeListPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/privacy-notices/new"
            element={
              <ProtectedWithLayout>
                <PrivacyNoticeWizardPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/privacy-notices/:id"
            element={
              <ProtectedWithLayout>
                <PrivacyNoticeDetailPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/privacy-notices/:id/edit"
            element={
              <ProtectedWithLayout>
                <PrivacyNoticeWizardPage editMode />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/tom"
            element={
              <ProtectedWithLayout>
                <TomListPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/tom/new"
            element={
              <ProtectedWithLayout>
                <TomWizardPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/tom/:id"
            element={
              <ProtectedWithLayout>
                <TomDetailPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/tom/:id/edit"
            element={
              <ProtectedWithLayout>
                <TomWizardPage editMode />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/data-subject-requests"
            element={
              <ProtectedWithLayout>
                <DsrListPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/data-subject-requests/new"
            element={
              <ProtectedWithLayout>
                <DsrWizardPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/data-subject-requests/:id"
            element={
              <ProtectedWithLayout>
                <DsrDetailPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/data-subject-requests/:id/edit"
            element={
              <ProtectedWithLayout>
                <DsrWizardPage editMode />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/breaches"
            element={
              <ProtectedWithLayout>
                <BreachListPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/breaches/new"
            element={
              <ProtectedWithLayout>
                <BreachWizardPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/breaches/:id"
            element={
              <ProtectedWithLayout>
                <BreachDetailPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/breaches/:id/edit"
            element={
              <ProtectedWithLayout>
                <BreachWizardPage editMode />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedWithLayout>
                <ReportsPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/import"
            element={
              <ProtectedWithLayout>
                <ImportPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/export"
            element={
              <ProtectedWithLayout>
                <ExportPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedWithLayout>
                <UserManagementPage />
              </ProtectedWithLayout>
            }
          />
          <Route
            path="/billing"
            element={
              <ProtectedWithLayout>
                <BillingPage />
              </ProtectedWithLayout>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
